import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import EmployeePopup from "./EmployeePopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { DepartmentDataDDL } from "../../../../Components/CommonDDL/DepartmentDataDDL"
import { EmployeeDataDDL } from "../../../../Components/CommonDDL/EmployeeDataDDL"
import { useRevalidator, useSearchParams } from "react-router-dom"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { DepartmentDDLAPI } from "../../../../Redux/DDLSlice"
import { EmployeeDeleteAPI, EmployeeTableDataAPI, EmployeeTableExportDataAPI } from "../../../../Redux/SidebarMasterSlice/EmployeeSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loader } from "react-overlay-loader"
import { Loading } from "../../../../Helper/Loading"
import { DesignationDDL } from "../../../../Components/CommonDDL/DesignationDDL"
import { EmployeeExportData } from "./EmployeeDataExportPage"
import { RoleNameDataDDL } from "../../../../Components/CommonDDL/RoleNameDataDDL"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"
import { ProjectNameGridDDL } from "../../../../Components/CommonDDL/ProjectNameGridDDL"
import { EmployeeGridDataDDL } from "../../../../Components/CommonDDL/EmployeeGridDataDDL"


export const Employee = () => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [IsPost, setIsPost] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [EmployeePopupShow, setEmployeePopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setEmployeePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setEmployeePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setEmployeePopupShow(false)
    }

    const [Department, setDepartment] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [EmployeeDDL, setEmployeeDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Role, setRole] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_EmployeeID: item.m_EmployeeID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(EmployeeDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.EmployeeDeleteData)

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setDepartment({
            ...Department,
            ID: 0,
            Label: 'Select...'
        })
        setEmployeeDDL({
            ...EmployeeDDL,
            ID: 0,
            Label: 'Select...'
        })
        setDesignation({
            ...Designation,
            ID: 0,
            Label: 'Select...'
        })
        setRole({
            ...Role,
            ID: 0,
            Label: 'Select...'
        })
        setProjectName({
            ...ProjectName,
            ID: 0,
            Label: 'Select...'
        })
        // setProjectType({
        //     ...ProjectType,
        //     ID: 0,
        //     Label: 'Select...'
        // })
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [Designation.ID, EmployeeDDL.ID])

    useEffect(() => {
        const data = {
            // M_DepartmentID: Department.ID,
            M_EmployeeID: EmployeeDDL.ID,
            M_DesignationID: Designation.ID,
            M_RoleID: 0,
            M_ProjectTypeID: RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID,
            M_ProjectID: ProjectName?.ID,
            EmployeeName: '',
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            handleEmployeeExport: handleEmployeeExport
        }
        // if (ProjectType?.ID != 0) {
        //     dispatch(EmployeeTableDataAPI({ data }))
        // }

        if ((RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID) != 0) {
            dispatch(EmployeeTableDataAPI({ data }))
        }
    }, [IsPost, To, IsClear, isSearch, ProjectType?.ID, M_ProjectTypeID])

    const { tableData, isLoading } = useSelector(state => state.EmployeeTableData)

    const handleEmployeeExport = () => {
        const data = {
            // M_DepartmentID: Department.ID,
            M_EmployeeID: EmployeeDDL.ID,
            M_DesignationID: Designation.ID,
            M_RoleID: 0,
            M_ProjectTypeID: RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID,
            M_ProjectID: ProjectName?.ID,
            EmployeeName: '',
            M_UsersID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        if (ProjectType?.ID != 0) {
            dispatch(EmployeeTableExportDataAPI({ data }))
        }
    }
    // , [IsPost, IsClear, isSearch])

    const { ExportTableData, isExportLoading } = useSelector(state => state.EmployeeTableExportData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="employee" listActive="masters" />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div className="col-12 d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="m-0 ps-1 py-1">Project Wise Officer Master</h5>

                                    <span style={{ fontSize: "16px", color: "gray", fontWeight: "bold" }}>
                                        Total Count: {tableData && tableData.table && tableData.table.length > 0 ? tableData.table[0].totalCount : 0}
                                    </span>

                                    <div className="d-flex align-items-center">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary mx-2" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <span className="mx-2">
                                                    <EmployeeExportData
                                                        ExcelData={ExportTableData}
                                                        name='Employee Master'
                                                    />
                                                </span>
                                        }
                                        <i className="fa-solid fa-plus btn btn-secondary"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1  rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">
                                            <div className="row py-1 rounded2 d-flex">
                                                {
                                                    RoleID == 1 &&
                                                    <div className="col-12 col-md-4 col-lg-2">
                                                        <ProjectTypeDataDDL
                                                            ProjectType={ProjectType}
                                                            setProjectType={setProjectType}
                                                            IsPost={IsPost}
                                                            M_ProjectTypeID={M_ProjectTypeID}
                                                        />
                                                    </div>
                                                }

                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <ProjectNameGridDDL
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                        ProjectName={ProjectName}
                                                        setProjectName={setProjectName}
                                                        APIFlag="ProjectWiseOfficer"
                                                        IsPost={IsPost}
                                                    />
                                                </div>
                                                {/* <div className="col-12 col-md-4 col-lg-3">
                                                    <RoleNameDataDDL
                                                        Role={Role}
                                                        setRole={setRole}
                                                        IsPost={IsPost}
                                                        M_ProjectTypeID={ProjectType?.ID}
                                                    />
                                                </div> */}
                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <DesignationDDL
                                                        Designation={Designation}
                                                        setDesignation={setDesignation}
                                                        IsPost={IsPost}
                                                        M_RoleID={Role?.ID}
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <EmployeeGridDataDDL
                                                        EmployeeID={EmployeeDDL}
                                                        setEmployeeID={setEmployeeDDL}
                                                        M_ProjectID={ProjectName?.ID}
                                                        M_DesignationID={Designation?.ID}
                                                        IsPost={IsPost}
                                                        M_ProjectTypeID={RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID}
                                                        Flag="ProjectWiseEmployee"
                                                    />
                                                </div>

                                                <div className="col-12 col-md-3 col-lg-2 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Name</th>
                                                            <th>Officer Name</th>
                                                            {/* <th>Role</th> */}
                                                            <th>Designation</th>
                                                            {/* <th>Department Name</th> */}
                                                            <th>Mobile Number</th>
                                                            <th>Email Id</th>
                                                            <th className="action-col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.projectName ? item.projectName : '-'}</td>
                                                                    <td>{item.employeeName ? item.employeeName : '-'}</td>
                                                                    {/* <td>{item.role ? item.role : '-'}</td> */}
                                                                    <td>{item.designationName ? item.designationName : '-'}</td>
                                                                    {/* <td>{item.departmentName ? item.departmentName : '-'}</td> */}

                                                                    <td>{item.mobileNumber ? item.mobileNumber : '-'}</td>
                                                                    <td>{item.email_ID ? item.email_ID : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <EmployeePopup
                                                                            open={EmployeePopupShow}
                                                                            handleIsPost={handleIsPost}
                                                                            item={item}
                                                                            Flag='Update'
                                                                        /> */}

                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <td colSpan={10}>No data found</td>
                                                        }

                                                    </tbody>

                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        EmployeePopupShow ?
                            <EmployeePopup
                                open={EmployeePopupShow}
                                // popupHeading="Location Name"                         
                                handleIsPost={handleIsPost}
                                handleOnCloseClick={handleOnCloseClick}
                                Flag={apiFlag}
                                rowData={rowData}
                            />
                            : <></>
                    }
                </div>
            </div>
        </>
    )
}